export default "__VITE_ASSET__CG9P4PY7__"